import { IdCard } from 'lucide-react';
import type { EntitySignalRow } from '@shared/flow/entity-signals';
import { ICON_LINK_CLASS } from '../links';
import { useCampaignMemberSidebarStore } from './campaign-member-sidebar-store';

/**
 * Item H (plan 2026-09-24-005, U18/D10) — the inline icon every
 * `signal_type === 'Campaign'` row in `ContactTimeline`'s Actions list shows,
 * regardless of `source_link` (PM decision 9: "no diagnosis step"). Opens
 * the SAME in-page member sidebar Item G's `CampaignMemberSidebarHost`
 * mounts (`useCampaignMemberSidebarStore`) — never a second sidebar/opener.
 *
 * `ICON_LINK_CLASS` + stop-propagation-on-click/keydown mirror
 * `SourceLinkIcon` (`../links.tsx`) exactly, so a Campaign row's icon looks
 * and behaves identically to every other inline row icon in this list.
 *
 * Renders `null` when `signal_instance_id` or `contact_id` is null — the
 * arm always sets `signal_type: 'Campaign'` uniformly across all four
 * tiers (`campaign.ts:419`), but a row without both ids has nothing for the
 * sidebar to key off of.
 */
export function CampaignMembershipIcon({ row }: { row: EntitySignalRow }) {
  const campaignId = row.signal_instance_id;
  const contactId = row.contact_id;
  if (!campaignId || !contactId) return null;

  return (
    <button
      type="button"
      title="View campaign membership"
      aria-label="View campaign membership"
      onClick={e => {
        e.stopPropagation();
        useCampaignMemberSidebarStore.getState().open({
          campaignId,
          contactId,
          observedAt: row.event_date,
          signalStatus: row.signal_status,
        });
      }}
      onKeyDown={e => e.stopPropagation()}
      className={ICON_LINK_CLASS}
    >
      <IdCard className="w-[15px] h-[15px]" />
    </button>
  );
}
